import { TableSortLabel } from '@mui/material';

import { MSorting, SortingColumn } from '../../../http/meas-service';
import { PaginationMeasStore } from '../../../stores/pagination-meas-store';

export const PAGE_SIZE_OPTIONS = [50, 100, 200, 500];

export type SortCol = Extract<SortingColumn, 'device' | 'sensor' | 'measure'>;

export function useMeasTableHandlers(store: PaginationMeasStore) {
    const handlePageChange = (_: unknown, newPage: number) => {
        store.setPage(newPage).catch(console.error);
    };

    const handleRowsPerPageChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        store.setPageSize(Number(e.target.value)).catch(console.error);
    };

    const handleSort = (col: SortCol) => {
        const order = store.sorting.column === col && store.sorting.order === 'asc' ? 'desc' : 'asc';
        store.setSorting({ column: col, order }).catch(console.error);
    };

    return { handlePageChange, handleRowsPerPageChange, handleSort };
}

export function makeSortLabel(sorting: MSorting, handleSort: (col: SortCol) => void) {
    return (col: SortCol, label: string, align?: 'right') => (
        <TableSortLabel
            active={sorting.column === col}
            direction={sorting.column === col ? sorting.order : 'asc'}
            onClick={() => handleSort(col)}
            sx={align === 'right' ? { flexDirection: 'row-reverse' } : undefined}
        >
            {label}
        </TableSortLabel>
    );
}
